import OrderRecieved from "../../assets/images/order_pick_logo.svg";
import CancelImage from "../../assets/images/Group 574 (3).svg";
import RTOImage from "../../assets/images/Group 578.png";
import InTransitImage from "../../assets/images/intransit_icn.svg";
import OutDeliveryImage from "../../assets/images/outfordelivery.svg";
import FailedImage from "../../assets/images/failedeliveryimage.svg";
import InTransitDelayImage from "../../assets/images/Group 573.svg";
import ShippedImage from "../../assets/images/Group 575.svg";
import DeliveredImage from "../../assets/images/delivered_icn.svg";

export const shipperTrack = (trackingDetails) => {
  const events = trackingDetails[0]?.tracking;
  if (!events) return [];

  // Events are newest first. A status with no step set (e.g. a new backend
  // status) falls back to the newest earlier event that has one, so the
  // progress bar never renders empty.
  for (const event of events) {
    const steps = stepsForStatus(event?.shipmentStatus);
    if (steps) return steps;
  }
  return [];
};

const stepsForStatus = (status) => {
  if (
    [
      "Awb Generated",
      "Shipment Created",
      "Order Assigned", 
      "Out for Pickup",
      "Pickup Failed",
      "To be Picked",
      "Packed",
      "Picked from Rack"
    ].includes(status)
  ) {
    return [
      {
        status: "Awb Generated",
        exist: true,
        CurrentStutusImage: OrderRecieved,
        hrLine: false,
        number: 1,
        left: "0%",
        leftIcon: "-1.6rem",
        lastline: true,
        existline: false,
      },
      {
        status: "Shipped",
        exist: false,
        CurrentStutusImage: null,
        hrLine: false,
        number: 1,
        left: "33.3%",
        lastline: true,
        existline: false,
      },
      {
        status: "Out for Delivery",
        exist: false,
        CurrentStutusImage: null,
        hrLine: false,
        number: 1,
        left: "66.6%",
        lastline: true,
        existline: false,
      },
      {
        status: "Delivered",
        exist: false,
        CurrentStutusImage: null,
        hrLine: false,
        number: 1,
        left: "100%",
        lastline: false,
        existline: false,
      },
    ];
  } else if (
    ["Picked-up"].includes(status)
  ) {
    return [
      {
        status: "Awb Generated",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 2,
        left: "0%",
        lastline: true,
        existline: true,
      },
      {
        status: "Picked-up",
        exist: true,
        CurrentStutusImage: ShippedImage,
        hrLine: false,
        number: 2,
        left: "33.3%",
        leftIcon: "15rem",
        lastline: true,
        existline: false,
      },
      {
        status: "Out for Delivery",
        exist: false,
        CurrentStutusImage: null,
        hrLine: false,
        number: 2,
        left: "66.6%",
        lastline: true,
        existline: false,
      },
      {
        status: "Delivered",
        exist: false,
        CurrentStutusImage: null,
        hrLine: false,
        number: 2,
        left: "100%",
        left: "100%",
        lastline: false,
        existline: false,
      },
    ];
  } else if (
    ["In-Transit", "Reached Destination City", "Reached Nearest Hub" ,"Transit Damage"].includes(
      status 
    )
  ) {
    return [
      {
        status: "Awb Generated",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 3,
        left: "0%",
        lastline: true,
        existline: true,
      },
      {
        status: "Picked-up",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 3,
        left: "33.3%",
        lastline: true,
        existline: true,
      },
      {
        status: "In-transit",
        exist: true,
        CurrentStutusImage: InTransitImage,
        hrLine: false,
        number: 3,
        left: "66.6%",
        leftIcon: "-1.6rem",
        lastline: true,
        existline: false,
      },
      {
        status: "Delivered",
        exist: false,
        CurrentStutusImage: null,
        hrLine: false,
        number: 3,
        left: "100%",
        lastline: false,
        existline: false,
      },
    ];
  } else if (
    ["Out for Delivery"].includes(
      status
    )
  ) {
    return [
      {
        status: "Awb Generated",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 3,
        left: "0%",
        lastline: true,
        existline: true,
      },
      {
        status: "Picked-up",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 3,
        left: "33.3%",
        lastline: true,
        existline: true,
      },
      {
        status: "Out for Delivery",
        exist: true,
        CurrentStutusImage: OutDeliveryImage,
        hrLine: false,
        number: 3,
        left: "66.6%",
        lastline: true,
        existline: false,
      },
      {
        status: "Delivered",
        exist: false,
        CurrentStutusImage: null,
        hrLine: false,
        number: 3,
        left: "100%",
        lastline: false,
        existline: false,
      },
    ];
  } else if (
    ["Delivered"].includes(status)
  ) {
    return [
      {
        status: "Awb Generated",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "0%",
        lastline: true,
        existline: true,
      },
      {
        status: "Picked-up",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "33.3%",
        lastline: true,
        existline: true,
      },
      {
        status: "Out for Delivery",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "66.6%",
        lastline: true,
        existline: true,
      },
      {
        status: "Delivered",
        exist: true,
        CurrentStutusImage: DeliveredImage,
        hrLine: false,
        number: 4,
        left: "100%",
        leftdot: "100%",
        lastline: false,
      },
    ];
  } else if (
    [
      "Failed Delivered",
      "Failed & Action Required",
      "Failed Delivered Non-RTO",
    ].includes(status)
  ) {
    return [
      {
        status: "Awb Generated",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "0%",
        lastline: true,
        existline: true,
      },
      {
        status: "Picked-up",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "33.3%",
        lastline: true,
        existline: true,
      },
      {
        status: "Out for Delivery",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "66.6%",
        lastline: true,
        existline: true,
      },
      {
        status: "Failed Delivered",
        exist: true,
        CurrentStutusImage: FailedImage,
        hrLine: false,
        number: 4,
        left: "100%",
        lastline: false,
        existline: false,
      },
    ];
  } else if (
    ["Delivery Delay"].includes(status)
  ) {
    return [
      {
        status: "Awb Generated",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 3,
        left: "0%",
        lastline: true,
        existline: true,
      },
      {
        status: "Picked-up",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 3,
        left: "33.3%",
        lastline: true,
        existline: true,
      },
      {
        status: "In-transit",
        exist: true,
        CurrentStutusImage: InTransitDelayImage,
        hrLine: false,
        number: 3,
        left: "66.6%",
        lastline: true,
        existline: false,
      },
      {
        status: "Delivered",
        exist: false,
        CurrentStutusImage: null,
        hrLine: false,
        number: 3,
        left: "100%",
        lastline: false,
      },
    ];
  } else if (
    ["Cancelled"].includes(status)
  ) {
    return [
      {
        status: "Awb Generated",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 2,
        left: "0%",
        lastline: true,
        existline: true,
      },
      {
        status: "Cancelled",
        exist: true,
        CurrentStutusImage: CancelImage,
        hrLine: false,
        number: 2,
        left: "33.3%",
        lastline: true,
        existline: false,
      },
      {
        status: "Out for Delivery",
        exist: false,
        CurrentStutusImage: null,
        hrLine: false,
        number: 2,
        left: "66.6%",
        lastline: true,
        existline: false,
      },
      {
        status: "Delivered",
        exist: false,
        CurrentStutusImage: null,
        hrLine: false,
        number: 2,
        left: "100%",
        lastline: false,
        existline: false,
      },
    ];
  } else if (
    ["RTO Initiated" , "RTO Freeze" ].includes(
      status
    )
  ) {
    return [
      {
        status: "Awb Generated",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "0%",
        lastline: true,
        existline: true,
      },
      {
        status: "Picked-up",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "33.3%",
        lastline: true,
        existline: true,
      },
      {
        status: "Failed Delivered",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "66.6%",
        lastline: true,
        existline: true,
      },
      {
        status: "Marked for Return",
        exist: true,
        CurrentStutusImage: RTOImage,
        hrLine: false,
        number: 4,
        left: "100%",
        lastline: false,
        existline: false,
      },
    ];
  } 
  else if (
    ["NDR Initiated"].includes(
      status
    )
  ) {
    return [
      {
        status: "Awb Generated",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "0%",
        lastline: true,
        existline: true,
      },
      {
        status: "Picked-up",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "33.3%",
        lastline: true,
        existline: true,
      },
      {
        status: "Failed Delivered",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "66.6%",
        lastline: true,
        existline: true,
      },
      {
        status: "Return Initiated",
        exist: true,
        CurrentStutusImage: RTOImage,
        hrLine: false,
        number: 4,
        left: "100%",
        lastline: false,
        existline: false,
      },
    ];
  } 
  
  else if (
    [
      "RTO In-Transit",
      "RTO Out for Delivery",
      "RTO Delivered",
      "RTO Not Delivered",
      "RTO Delivery Delay",
    ].includes(status)
  ) {
    return [
      {
        status: "Awb Generated",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "0%",
        lastline: true,
        existline: true,
      },
      {
        status: "Picked-up",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "33.3%",
        lastline: true,
        existline: true,
      },
      {
        status: "Failed Delivered",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 4,
        left: "66.6%",
        lastline: true,
        existline: true,
      },
      {
        status: "Returned to Shipper",
        exist: true,
        CurrentStutusImage: RTOImage,
        hrLine: false,
        number: 4,
        left: "100%",
        lastline: false,
        existline: false,
      },
    ];
  } else if (
    ["Lost", "Damaged", "Status Not Defined"].includes(
      status
    )
  ) {
    return [
      {
        status: "Awb Generated",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 3,
        left: "0%",
        lastline: true,
        existline: true,
      },
      {
        status: "Picked-up",
        exist: true,
        CurrentStutusImage: null,
        hrLine: true,
        number: 3,
        left: "33.3%",
        lastline: true,
        existline: true,
      },
      {
        status: "Pending with Shipper",
        exist: true,
        CurrentStutusImage: RTOImage,
        hrLine: false,
        number: 3,
        left: "66.6%",
        lastline: true,
        existline: false,
      },
      {
        status: "Delivered",
        exist: false,
        CurrentStutusImage: null,
        hrLine: false,
        number: 3,
        left: "100%",
        lastline: false,
        existline: false,
      },
    ];
  }
};
